import React, { useEffect, useMemo, useState } from 'react'
import { Helmet } from 'react-helmet'
import { Link } from 'react-router-dom'
import { Announcement } from '../../components/Dashboard/homepage/Announcement'
import { BoughtSymbol } from '../../components/Dashboard/svgs/BoughtSymbol'
import { ExchangeSymbol } from '../../components/Dashboard/svgs/ExchangeSymbol'
import { NairaSymbol } from '../../components/Dashboard/svgs/NairaSymbol'
import { SoldSymbol } from '../../components/Dashboard/svgs/SoldSymbol'
import { WithdrawSymbol } from '../../components/Dashboard/svgs/WithdrawSymbol'
import { TradesTableSkeleton } from '../../components/Dashboard/transactions/TradesTableSkeleton'
import { useGetOrdersQuery, useGetStatsQuery, } from '../../features/order/orderSlice'
import { useGetAnnouncementQuery, useGetBannersQuery } from '../../features/strapi/strapiSlice'
import { useGetWalletQuery } from '../../features/wallet/walletSlice'
import { useGetWithdrawStatsQuery } from '../../features/withdraws/withdrawSlice'
import { Loader } from '../../shared/Loader'
import { Carousel } from 'react-responsive-carousel'
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import { useGetCurrenciesQuery } from '../../features/trade&coins/coinSlice'
import { AiFillTrophy, AiOutlineEye, AiOutlineEyeInvisible } from "react-icons/ai";
import { TopHottestCards } from '../../components/Dashboard/homepage/TopHottestCards';

const currenciesSelect = [
  { name: 'NGN', value: 'ngn', symbol: '₦' },
  { name: 'GHS', value: 'ghs', symbol: 'GH₵' },
  { name: 'USD', value: 'usd', symbol: '$' },
]

async function updateCurrency(currency: string, userId?: string) {
  localStorage.setItem(`currency`, currency)
}

function getCurrency() {
  return localStorage.getItem(`currency`) || "ngn"
}

export const HomePage = () => {
  const { data: stats, isLoading } = useGetStatsQuery()
  const { data: wallet, isLoading: isWalletLoading } = useGetWalletQuery()
  const { data: withdrawStats, isLoading: isWithdrawLoading } =
    useGetWithdrawStatsQuery()
  const {
    data: orders,
    isLoading: isOrdersLoading,
    isFetching: isOrdersFetching,
  } = useGetOrdersQuery({
    page: 1,
    limit: 10,
  })

  const [currency, setCurrency] = useState(getCurrency())
  const [isBalanceHidden, setIsBalanceHidden] = useState(() => localStorage.getItem("@balance_hidden") === "true")

  const toggleBalanceVisibility = () => {
    const newValue = !isBalanceHidden
    setIsBalanceHidden(newValue)
    localStorage.setItem("@balance_hidden", String(newValue))
  }

  const { data: currencies, isLoading: isCurrencyLoading } = useGetCurrenciesQuery()

  const balance = useMemo(() => {

    console.log("working")
    let bal = 0;
    switch (currency) {
      case "ngn":
        bal = wallet?.balance
        break;
      case "ghs":
        bal = wallet?.balance / (currencies?.find((currency: any) => currency?.name === "ghs")?.rate || 0)
        break;
      case "usd":
        bal = wallet?.balance / (currencies?.find((currency: any) => currency?.name === "usd")?.rate || 0)
        break;
      default:
        bal = 0
        break;
    }

    if (bal == Infinity) bal = 0

    return bal
  }, [wallet, currencies, currency])

  useEffect(() => {
    updateCurrency(currency)
  }, [currency])

  console.log("balance", balance)

  const { data: announements, isLoading: isAnnouncementLoading } =
    useGetAnnouncementQuery({ page: 1, pageSize: 3 })

  const { data: banners, isLoading: isBannersLoading } = useGetBannersQuery();


  return (
    <div className='font-dashboard pt-8 pb-12 lg:px-4'>
      {/* meta data --- */}
      <Helmet>
        <title>User | Dashboard</title>
        <meta name='description' content='User | Dashboard'></meta>
        <link rel='canonical' href='https://gcbuying.com/app/home' />
      </Helmet>
      {/* meta data --- */}

      <div className='container-lg grid grid-cols-1 lg:grid-cols-4 gap-4'>
        <div className='lg:col-span-3 min-h-screen'>
          <div className='bg-black flex justify-between px-4 lg:px-10 py-10 overflow-scroll lg:overflow-auto'>
            <div className='flex flex-col justify-between gap-6 bg-[url("/images/dashboard/OBJECTS.png")] bg-no-repeat bg-bottom'>
              <div>
                <p className='text-xl text-white/40 font-light flex items-center gap-2'>
                  Wallet balance
                  <button onClick={toggleBalanceVisibility} className="text-white/60 hover:text-white transition-colors">
                    {isBalanceHidden ? <AiOutlineEyeInvisible size={20} /> : <AiOutlineEye size={20} />}
                  </button>
                </p>
                <div className='flex items-center space-x-4'>
                  <h1 className='text-white flex items-center gap-2'>
                    <span className='font-semibold'>
                      {
                        currenciesSelect.find((cur) => cur.value === currency)?.symbol
                      }
                    </span>{' '}
                    {isWalletLoading ? (
                      <div className='h-12 w-48 bg-gray-500 animate-pulse' />
                    ) : isBalanceHidden ? (
                      <span>••••••</span>
                    ) : (
                      balance?.toFixed(2)
                    )}

                  </h1>
                  <select name="currency" id="currency-select" className='px-2 py-1 rounded-lg bg-primary outline-none'
                    onChange={(e) => setCurrency(e.target.value)}
                  >
                    {currenciesSelect.map((cur) => (
                      <option value={cur.value} selected={currency === cur.value}>{cur.name}</option>
                    ))}
                  </select>
                </div>

                {isWalletLoading ? (
                  <div className='h-6 w-48 bg-gray-500 animate-pulse mt-2' />
                ) : !isBalanceHidden && (
                  <p className='text-white flex items-center'> <NairaSymbol size={12} /> <span className='ml-1'>{wallet?.balance.toFixed(2)}</span></p>
                )}

                <div className="flex mt-2 gap-2">
                  <AiFillTrophy size={24} className="text-yellow-600" />
                  <p className="text-white flex items-center gap-2">
                    {isBalanceHidden ? "••••••" : wallet?.rewardBalance?.toFixed(2)} {!isBalanceHidden && <NairaSymbol size={12} />}
                  </p>
                </div>

                <div className="mt-4 flex gap-2">
                  <Link to="/app/deposit">
                    <button className="px-4 py-2 rounded-lg bg-primary text-gray-800 font-medium hover:bg-primary/90 transition-colors">
                      Deposit
                    </button>
                  </Link>
                  <Link to="/app/withdraw">
                    <button className="px-4 py-2 rounded-lg bg-primary text-gray-800 font-medium hover:bg-primary/90 transition-colors">
                      Withdraw
                    </button>
                  </Link>
                </div>
              </div>

              <div className='flex items-center divide-x-2 divide-gray-500'>
                <div className='flex flex-col justify-center pr-4 gap-1 md:gap-2'>
                  <div className='flex items-center gap-2'>
                    <div className='md:border md:border-white md:rounded-full box-content md:p-2'>
                      <ExchangeSymbol size={12} />
                    </div>
                    <p className='text-white/40 font-light text-sm md:text-base'>
                      Total trades
                    </p>
                  </div>

                  <p className='text-white flex items-center text-lg md:text-xl gap-2 md:gap-4'>
                    <span>
                      <NairaSymbol size={16} />
                    </span>{' '}
                    {isLoading ? (
                      <div className='h-4 w-24 bg-gray-500 animate-pulse' />
                    ) : (
                      stats?.trade
                    )}
                  </p>
                </div>

                <div className='flex flex-col justify-center gap-1 md:gap-2 px-4 min-w-max'>
                  <div className='flex items-center gap-2'>
                    <div className='md:border md:border-yellow-500 md:rounded-full box-content md:p-2 text-yellow-500'>
                      <SoldSymbol size={12} className='text-yellow-500' />
                    </div>
                    <p className='text-white/40 text-sm md:text-base font-light'>
                      Total sold
                    </p>
                  </div>

                  <p className='text-white flex items-center text-lg md:text-xl gap-2'>
                    <span>
                      <NairaSymbol size={16} />
                    </span>{' '}
                    {isLoading ? (
                      <div className='h-4 w-24 bg-gray-500 animate-pulse' />
                    ) : (
                      stats?.sell
                    )}
                  </p>
                </div>

                <div className='flex flex-col justify-center gap-1 md:gap-2 px-4 min-w-max'>
                  <div className='flex items-center gap-2'>
                    <div className='md:border md:border-green-500 md:rounded-full box-content md:p-2 text-green-500'>
                      <BoughtSymbol size={12} className='text-green-500' />
                    </div>
                    <p className='text-white/40 text-sm md:text-base font-light'>
                      Total bought
                    </p>
                  </div>

                  <p className='text-white flex items-center text-xl gap-2'>
                    <span>
                      <NairaSymbol size={16} />
                    </span>{' '}
                    {isLoading ? (
                      <div className='h-4 w-24 bg-gray-500 animate-pulse' />
                    ) : (
                      stats?.buy
                    )}
                  </p>
                </div>

                <div className='flex flex-col justify-center gap-1 md:gap-2 pl-4 min-w-max'>
                  <div className='flex items-center gap-2'>
                    <div className='md:border md:border-red-500 md:rounded-full box-content md:p-2 text-red-500'>
                      <WithdrawSymbol size={12} className='text-red-500' />
                    </div>
                    <p className='text-white/40 font-light text-sm md:text-base'>
                      Total withdrawals
                    </p>
                  </div>

                  <p className='text-white flex items-center text-lg md:text-xl gap-2'>
                    <span>
                      <NairaSymbol size={16} />
                    </span>{' '}
                    {isWithdrawLoading ? (
                      <div className='h-4 w-24 bg-gray-500 animate-pulse' />
                    ) : (
                      withdrawStats?.completed
                    )}
                  </p>
                </div>
              </div>
            </div>
            <div className='lg:block hidden'>
              <img src='/images/dashboard/wallet.png' alt='wallet image' />
            </div>
          </div>


          {/* Recent transaction table  ------------------------------------ */}
          <div className='bg-black flex flex-col gap-4 px-4 lg:px-10 py-10 mt-6'>

            <div className='flex md:hidden mb-8 justify-center gap-4'>
              <Link to='/app/giftcard'>
                <button className='px-3 py-2 rounded-2xl bg-primary text-gray-800 text-sm'>
                  Sell Gift Card
                </button>
              </Link>
              <Link to='/app/buy-giftcards'>
                <button className='px-3 py-2 rounded-2xl bg-primary text-gray-800 text-sm'>
                  Buy Giftcard
                </button>
              </Link>
              <Link to='/app/quick-sell'>
                <button className='px-3 py-2 rounded-2xl bg-primary text-gray-800 text-sm'>
                  Sell Crypto
                </button>
              </Link>
            </div>

            <div className='flex justify-between'>
              <h3 className='text-primary text-xl font-medium'>
                Recent Orders
              </h3>

              <div className='hidden md:flex items-center gap-4'>
                <Link to='/app/giftcard'>
                  <button className='px-3 py-2 rounded-2xl bg-primary text-gray-800 text-sm'>
                    Sell Giftcard
                  </button>
                </Link>
                <Link to='/app/buy-giftcards'>
                  <button className='px-3 py-2 rounded-2xl bg-primary text-gray-800 text-sm'>
                    Buy Giftcard
                  </button>
                </Link>
                <Link to='/app/quick-sell'>
                  <button className='px-3 py-2 rounded-2xl border border-primary text-primary text-sm'>
                    Sell Crypto
                  </button>
                </Link>

                <Link to='/app/withdraw'>
                  <button className='px-3 py-2 rounded-2xl bg-primary text-gray-800 text-sm'>
                    Withdraw Now
                  </button>
                </Link>
              </div>
            </div>

            <div className='overflow-x-auto relative'>
              {isOrdersLoading || isOrdersFetching ? (
                <TradesTableSkeleton />
              ) : orders?.data.length == 0 ? (
                <div className='w-full bg-red font-light text-white/40 my-24 text-center'>
                  No record found
                </div>
              ) : (
                <table className='w-full text-sm text-left text-gray-400'>
                  <thead className='text-xs uppercase bg-gray-700 text-gray-300'>
                    <tr>
                      <th scope='col' className='py-3 px-6'>
                        Transaction ID
                      </th>
                      <th scope='col' className='py-3 px-6'>
                        Type
                      </th>
                      <th scope='col' className='py-3 px-6'>
                        Asset
                      </th>
                      <th scope='col' className='py-3 px-6'>
                        Amount
                      </th>
                      <th scope='col' className='py-3 px-6'>
                        Rate
                      </th>
                      <th scope='col' className='py-3 px-6'>
                        Status
                      </th>
                      <th scope='col' className='py-3 px-6'></th>
                    </tr>
                  </thead>
                  <tbody>
                    {orders?.data?.map((data: any) => (
                      <tr className='border-b bg-transparent border-gray-700'>
                        <th
                          scope='row'
                          className='py-4 px-6 font-medium whitespace-nowrap text-white'
                        >
                          {data?._id}
                        </th>
                        <td className='py-4 px-6'>{data?.type}</td>
                        <td className='py-4 px-6'>{data?.coin?.symbol}</td>
                        <td className='py-4 px-6'>{data?.quantity}</td>
                        <td className='py-4 px-6'>{data?.price}</td>
                        <td className='py-4 px-6'>
                          {data?.status === 'completed' ? (
                            <div className='badge-success px-4 py-2 rounded-full'>
                              Completed
                            </div>
                          ) : data?.status === 'pending' ? (
                            <div className='badge-warning px-4 py-2 rounded-full'>
                              Pending
                            </div>
                          ) : data.status === 'processing' ? (
                            <div className='badge-info px-4 py-2 rounded-full'>
                              Processing
                            </div>
                          ) : data.status === 'suspended' ? (
                            <div className='badge-suspended px-4 py-2 rounded-full'>
                              Suspended
                            </div>
                          ) : (
                            <div className='badge-error px-4 py-2 rounded-full'>
                              Cancelled
                            </div>
                          )}
                        </td>

                        <td className='py-4 px-6'>
                          <Link
                            to={
                              data?.type === 'trade'
                                ? `/app/transaction/trades/${data._id}`
                                : `/app/transaction/orders/${data._id}`
                            }
                          >
                            <button className='box-content text-blue-500 text-xs'>
                              Details
                            </button>
                          </Link>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              )}
            </div>
          </div>
          {/* Recent transaction table end ------------------------------------ */}
        </div>

        <div className='bg-black min-h-[105vh] px-2 py-4 z-0'>
          <div className='flex flex-col gap-4 max-w-[500px] mx-auto'>
            {/* Banners */}
            {isBannersLoading ? (
              <div className='h-24 w-full bg-gray-500 animate-pulse' />
            ) : (
              <Carousel
                autoPlay={true}
                showThumbs={false}
                infiniteLoop={true}
              >
                {
                  banners?.data?.map((banner: any, index: number) => {
                    return (
                      <div key={index}>
                        <img src={banner?.attributes?.image?.data?.attributes?.url} />
                      </div>
                    )
                  })
                }
              </Carousel>
            )}

            {/* Top Hottest Cards */}
            <TopHottestCards />

            {/* Announcements */}
            {isAnnouncementLoading ? (
              <div className='flex justify-center items-center py-8'>
                <Loader />
              </div>
            ) : (
              <div className='space-y-4'>
                {announements?.data.map((announement: any) => (
                  <Announcement
                    key={announement.id}
                    title={announement?.attributes.title}
                    description={announement?.attributes.description}
                    publishedAt={announement?.attributes.publishedAt}
                  />
                ))}
              </div>
            )}

            <Link
              to='/app/announcements'
              className='btn-secondary px-4 py-2 text-center mt-4'
            >
              <button>View more</button>
            </Link>
          </div>
        </div>
      </div>
    </div>
  )
}
